export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  imageUrl: string;
  tags: string[];
  author: string;
  publishDate: string;
  readCount: number;
  commentCount: number;
  shareCount: number;
  isHot: boolean;
  isNew: boolean;
}

export const articles: Article[] = [
  {
    slug: 'dingzhen-chuxing-baoguang',
    title: '某千万粉丝网红被曝私下辱骂粉丝，聊天记录完整流出',
    excerpt: '一位拥有超过2000万粉丝的知名网红近日被曝光在私密群聊中多次辱骂粉丝，聊天记录详细展示了该网红对粉丝的各种不尊重言论，引发全网热议。',
    content: '<p>近日，一则关于某千万粉丝级别网红的爆料在社交平台引发轩然大波。据知情人士透露，该网红在多个私密粉丝群中频繁发表不当言论，对支持自己的粉丝进行言语攻击和羞辱。</p><p>根据流出的聊天记录显示，该网红曾在群聊中吐槽粉丝"没钱还爱装"、"整天就知道白嫖"，甚至对给自己送礼物的粉丝也毫不客气地评价为"送的东西都不值钱"。</p><p>更令人震惊的是，该网红还在内部群中透露自己如何"割韭菜"——通过精心设计的营销策略让粉丝不断掏钱，并嘲笑粉丝"太好骗了"。</p><p>这些聊天记录一经曝光，立即在各大社交平台引发强烈反响。多位曾是该网红忠实粉丝的网友表示"心都碎了"，并纷纷取消关注。</p><p>截至目前，该网红尚未对此事做出公开回应。但其多个社交媒体账号的粉丝数已经开始出现明显下滑。</p><p>业内人士分析认为，此次事件对该网红的商业价值将造成重大打击，多个品牌方已经在考虑终止与其的代言合作。</p>',
    category: 'wanghong-tafang',
    categoryName: '网红塌房',
    imageUrl: 'https://readdy.ai/api/search-image?query=Broken%20smartphone%20screen%20with%20leaked%20chat%20messages%20visible%2C%20dramatic%20warm%20crimson%20lighting%2C%20abstract%20digital%20privacy%20breach%20concept%2C%20Chinese%20social%20media%20scandal%20aesthetic%2C%20high%20contrast%2C%20editorial%20photography%2C%20clean%20simple%20dark%20background%2C%20no%20text&width=600&height=400&seq=article-dingzhen&orientation=landscape',
    tags: ['网红塌房', '聊天记录', '粉丝', '人设崩塌'],
    author: '吃瓜小编',
    publishDate: '2026-07-07',
    readCount: 1280000,
    commentCount: 35600,
    shareCount: 89200,
    isHot: true,
    isNew: true,
  },
  {
    slug: 'mingxing-yehuisinian',
    title: '顶流明星被拍到深夜私会神秘女子，疑似恋情曝光',
    excerpt: '某顶流男星被狗仔拍到深夜与一名神秘女子共同进入某高档酒店，两人举止亲密，疑似新恋情浮出水面，粉丝群体分裂严重。',
    content: '<p>昨晚，知名娱乐狗仔在社交平台发布了一组照片，记录了某顶流男星深夜与一名神秘女子同行的画面。照片中两人举止亲密，最终一同进入北京某五星级酒店，直到次日清晨才先后离开。</p><p>据悉，该男星此前一直对外宣称单身，其粉丝群体中也有大量"女友粉"。此次恋情曝光的消息一出，立即在粉丝群体中引发巨大震动。</p><p>有粉丝表示"支持哥哥恋爱自由"，但也有大量粉丝表示无法接受，纷纷在社交平台表达不满，甚至有人发起了"脱粉"行动。</p><p>该男星工作室目前尚未对此事做出任何回应。但据圈内人士透露，该神秘女子疑似是某知名企业家之女，两人已经秘密交往数月。</p><p>值得一提的是，该男星此前曾在多个公开场合强调自己是"单身"，此次被拍到约会画面，也让不少网友质疑其"人设造假"。</p>',
    category: 'yule-bagua',
    categoryName: '娱乐八卦',
    imageUrl: 'https://readdy.ai/api/search-image?query=Blurred%20night%20street%20scene%20with%20luxury%20hotel%20entrance%2C%20paparazzi%20style%20photography%2C%20warm%20amber%20streetlights%2C%20dramatic%20mystery%20atmosphere%2C%20Chinese%20celebrity%20gossip%20aesthetic%2C%20high%20contrast%2C%20editorial%20style%2C%20clean%20simple%20background%2C%20no%20text&width=600&height=400&seq=article-yehui&orientation=landscape',
    tags: ['恋情曝光', '顶流明星', '狗仔', '私会'],
    author: '吃瓜小编',
    publishDate: '2026-07-06',
    readCount: 2560000,
    commentCount: 78200,
    shareCount: 156000,
    isHot: true,
    isNew: true,
  },
  {
    slug: 'zhibozhujian-toumao',
    title: '知名带货主播被曝偷税漏税，金额高达数千万',
    excerpt: '税务部门最新通报显示，某知名直播带货主播因偷逃个人所得税被追缴税款并处罚金，总金额高达数千万元，直播间已紧急停播。',
    content: '<p>今日上午，国家税务总局在其官方网站发布通报，某知名直播带货主播因涉嫌偷逃个人所得税被立案调查。经查实，该主播在2024年至2025年期间，通过虚假申报等方式少缴个人所得税，涉及金额高达数千万元。</p><p>税务部门已依法对该主播作出追缴税款、加收滞纳金并处罚款的处理决定，总金额超过5000万元。</p><p>消息公布后，该主播的所有社交媒体账号均已设为私密状态，原定今晚的直播带货活动也已紧急取消。多个品牌方迅速发布声明，宣布终止与该主播的合作关系。</p><p>这是继去年多名头部主播因税务问题被查处后，又一起直播行业重大税务案件。业内专家表示，直播行业的高收入群体已成为税务部门重点监管对象。</p><p>目前，该主播的个人账号粉丝数已从此前的3500万降至不足3000万，损失惨重。</p>',
    category: 'wanghong-tafang',
    categoryName: '网红塌房',
    imageUrl: 'https://readdy.ai/api/search-image?query=Tax%20documents%20with%20red%20stamps%20and%20warning%20signs%2C%20dramatic%20warm%20crimson%20lighting%2C%20financial%20scandal%20concept%2C%20Chinese%20tax%20investigation%20aesthetic%2C%20high%20contrast%2C%20editorial%20photography%2C%20clean%20simple%20background%2C%20no%20text&width=600&height=400&seq=article-toushui&orientation=landscape',
    tags: ['偷税漏税', '带货主播', '直播行业', '税务'],
    author: '吃瓜小编',
    publishDate: '2026-07-06',
    readCount: 1980000,
    commentCount: 45200,
    shareCount: 67800,
    isHot: true,
    isNew: false,
  },
  {
    slug: 'zongyi-jiamu-neimu',
    title: '某热门综艺被曝剧本造假，选手晋级全部内定',
    excerpt: '前综艺节目工作人员匿名爆料，揭露某热门选秀综艺存在严重的剧本造假行为，所有选手的晋级淘汰均由节目组提前安排。',
    content: '<p>近日，一位自称曾在某热门选秀综艺节目组工作过的匿名人士在社交平台发布了长篇爆料，详细揭露了该节目的剧本造假内幕。</p><p>据该爆料人称，节目中所有的选手晋级和淘汰结果均由节目组在录制前就已经确定，所谓的"观众投票"和"导师打分"完全是走过场。节目组会根据选手的商业价值和话题度来安排剧本走向。</p><p>更令人震惊的是，一些看似"意外"的冲突场面——比如选手之间的争吵、导师的"即兴"点评——实际上都有详细的剧本，甚至连选手的表情和台词都是提前设计好的。</p><p>该爆料还指出，节目组会刻意剪辑某些选手的负面形象，制造争议话题以获取流量，而这些被"黑"的选手往往在参赛前就已经知道自己的角色定位。</p><p>此爆料引发了观众对综艺节目真实性的广泛讨论。有网友表示"早就猜到是剧本"，但也有忠实观众表示"受到了欺骗"。</p><p>截至目前，该综艺节目的制作方尚未对此做出回应。</p>',
    category: 'zongyi-bagua',
    categoryName: '综艺八卦',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20script%20papers%20scattered%2C%20dramatic%20stage%20lighting%2C%20warm%20amber%20and%20crimson%20tones%2C%20Chinese%20variety%20show%20behind%20scenes%2C%20high%20contrast%2C%20editorial%20style%2C%20clean%20simple%20background%2C%20no%20text&width=600&height=400&seq=article-zongyi&orientation=landscape',
    tags: ['综艺造假', '剧本', '选秀', '内幕'],
    author: '吃瓜小编',
    publishDate: '2026-07-05',
    readCount: 1650000,
    commentCount: 38900,
    shareCount: 54300,
    isHot: true,
    isNew: false,
  },
  {
    slug: 'nvyanyuan-pianchang-shuaidapai',
    title: '某女演员片场耍大牌，迟到六小时还骂哭工作人员',
    excerpt: '多位剧组工作人员联合爆料，某知名女演员在拍摄期间多次迟到、耍大牌，甚至将一名年轻工作人员骂哭，引发圈内热议。',
    content: '<p>日前，多位来自同一个电视剧剧组的工作人员在社交平台匿名爆料，指控某知名女演员在拍摄期间存在严重的"耍大牌"行为。</p><p>根据多位工作人员的联合描述，该女演员在为期三个月的拍摄期间，几乎每天都迟到，最严重的一次迟到了整整六个小时，导致全组人员白白等待。当工作人员提醒她注意时间时，她不仅没有道歉，反而破口大骂，将一名刚入职的年轻女助理当场骂哭。</p><p>此外，该女演员对剧组提供的住宿和餐饮条件也百般挑剔，曾因酒店房间"不够大"而当众摔东西，要求剧组更换五星级酒店总统套房。</p><p>剧组化妆师也爆料称，该女演员对妆容造型极为苛刻，经常在拍摄中途要求重新化妆，导致拍摄进度严重延误。</p><p>此消息传出后，多位与该女演员合作过的幕后人员也纷纷站出来表达类似经历。有制片人含蓄表示"以后不会再找她合作"。</p><p>目前，该女演员的经纪团队已发布声明，否认所有指控，称"这些都是恶意诽谤"。</p>',
    category: 'yingshi-bagua',
    categoryName: '影视八卦',
    imageUrl: 'https://readdy.ai/api/search-image?query=Empty%20film%20set%20with%20lonely%20director%20chair%2C%20dramatic%20warm%20lighting%2C%20abandoned%20atmosphere%2C%20Chinese%20film%20set%20aesthetic%2C%20high%20contrast%2C%20editorial%20photography%2C%20clean%20simple%20background%2C%20no%20text&width=600&height=400&seq=article-nvyanyuan&orientation=landscape',
    tags: ['耍大牌', '女演员', '剧组', '片场'],
    author: '吃瓜小编',
    publishDate: '2026-07-04',
    readCount: 2130000,
    commentCount: 67800,
    shareCount: 89200,
    isHot: false,
    isNew: true,
  },
  {
    slug: 'wanghong-daizheng-shipin',
    title: '网红直播带货翻车，产品被检测含违禁成分',
    excerpt: '某知名美妆网红带货的面膜产品被消费者送去检测，结果显示含有多种违禁激素成分，该网红直播间已被紧急关闭。',
    content: '<p>一场由消费者自发发起的检测行动，揭开了一个令人震惊的真相。某知名美妆网红长期带货的一款"纯天然"面膜产品，经权威机构检测后，被发现含有多种违禁激素成分。</p><p>据悉，该网红在直播中多次强调该产品"零添加"、"纯天然"、"孕妇可用"，吸引了大量粉丝购买。但有消费者使用后出现严重过敏反应，便将产品送去检测。</p><p>检测报告显示，该面膜中含有氯倍他索丙酸酯等多种糖皮质激素，长期使用可能导致皮肤萎缩、毛细血管扩张等严重问题，甚至可能影响内分泌系统。</p><p>消息曝光后，该网红连夜删除了所有关于该产品的推广视频，但其行为被网友截图保存。多位皮肤科医生公开发声，警告消费者停止使用该产品。</p><p>市场监管部门已介入调查，该网红的所有直播带货活动已被平台紧急暂停。据悉，受影响的消费者可能超过10万人。</p>',
    category: 'wanghong-tafang',
    categoryName: '网红塌房',
    imageUrl: 'https://readdy.ai/api/search-image?query=Broken%20cosmetics%20and%20laboratory%20test%20tubes%2C%20dramatic%20warm%20crimson%20lighting%2C%20health%20scandal%20concept%2C%20Chinese%20beauty%20product%20scandal%20aesthetic%2C%20high%20contrast%2C%20editorial%20photography%2C%20clean%20simple%20background%2C%20no%20text&width=600&height=400&seq=article-daizheng&orientation=landscape',
    tags: ['带货翻车', '违禁成分', '美妆', '消费者权益'],
    author: '吃瓜小编',
    publishDate: '2026-07-03',
    readCount: 3450000,
    commentCount: 124000,
    shareCount: 256000,
    isHot: false,
    isNew: false,
  },
  {
    slug: 'yulequan-sizhe-fengbo',
    title: '娱乐圈又一明星被实名举报，涉及多项严重指控',
    excerpt: '一位自称是知情人士的网友实名举报某知名艺人，指控其涉及多项违法违纪行为，并附上了部分证据材料。',
    content: '<p>今日凌晨，一位自称掌握内幕的网友在社交平台发布实名举报信，指控某知名艺人涉及多项严重违法违纪行为，引发轩然大波。</p><p>该举报人在长文中详细列举了该艺人的多项不当行为，包括但不限于：利用明星身份进行非法集资、参与境外赌博、以及利用个人影响力干预司法公正等。举报人表示，自己手中握有相关证据，并愿意配合有关部门调查。</p><p>举报信发布后，相关话题迅速登上热搜第一。该艺人的粉丝群体反应激烈，有人质疑举报者动机不纯，也有人表示"坐等真相"。</p><p>截至目前，该艺人及其工作室尚未对此做出公开回应。多位圈内人士在接受采访时选择了沉默或者表示"不方便评论"。</p><p>法律界人士指出，如果举报内容属实，该艺人可能面临严重的法律后果。但如果属于恶意诽谤，举报人也需要承担相应的法律责任。</p>',
    category: 'heiliao-baoguang',
    categoryName: '黑料曝光',
    imageUrl: 'https://readdy.ai/api/search-image?query=Official%20document%20with%20red%20seal%20and%20dramatic%20shadows%2C%20warm%20crimson%20lighting%2C%20legal%20scandal%20concept%2C%20Chinese%20official%20document%20aesthetic%2C%20high%20contrast%2C%20editorial%20photography%2C%20clean%20simple%20background%2C%20no%20text&width=600&height=400&seq=article-jubao&orientation=landscape',
    tags: ['实名举报', '艺人', '违法', '黑料'],
    author: '吃瓜小编',
    publishDate: '2026-07-03',
    readCount: 4120000,
    commentCount: 156000,
    shareCount: 289000,
    isHot: false,
    isNew: false,
  },
  {
    slug: 'zhibo-jian-liangdian',
    title: '直播间惊现"翻车"名场面，千万观众在线围观',
    excerpt: '某知名主播在直播过程中意外出现技术故障，导致其真实颜值暴露，与平时滤镜美颜后的形象差距巨大，引发全民热议。',
    content: '<p>昨晚，一场意外的直播"翻车"事件席卷了整个互联网。某知名主播在直播过程中，其使用的美颜滤镜突然失效，真实面貌瞬间暴露在千万观众面前。</p><p>该主播此前一直以"仙女颜值"著称，每次直播都使用重度美颜滤镜。然而当滤镜意外关闭后，观众发现其真实长相与直播画面中的形象存在巨大差距，一时间弹幕刷屏，网友纷纷截图表态。</p><p>"这是同一个人吗？"、"我终于相信美颜的威力了"、"原来滤镜这么强大"——直播间弹幕瞬间爆炸，同时在线观看人数从平日的200万飙升至超过800万。</p><p>该主播在意识到滤镜失效后，迅速结束了直播。但相关的截图和录屏已经在各大社交平台疯传，成为当日最热门话题。</p><p>事件发生后，该主播发布了一段视频回应称"每个人都有追求美的权利"，但评论区依然两极分化严重。有粉丝力挺"天生丽质"，也有网友调侃"美颜是第一生产力"。</p>',
    category: 'shipin-chigua',
    categoryName: '视频吃瓜',
    imageUrl: 'https://readdy.ai/api/search-image?query=Split%20screen%20showing%20filtered%20vs%20real%20appearance%2C%20dramatic%20warm%20lighting%2C%20digital%20glitch%20effect%2C%20Chinese%20live%20streaming%20fail%20concept%2C%20high%20contrast%2C%20editorial%20style%2C%20clean%20simple%20background%2C%20no%20text&width=600&height=400&seq=article-zhibo&orientation=landscape',
    tags: ['直播翻车', '美颜滤镜', '颜值', '名场面'],
    author: '吃瓜小编',
    publishDate: '2026-07-02',
    readCount: 5200000,
    commentCount: 189000,
    shareCount: 345000,
    isHot: false,
    isNew: false,
  },
];

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getHotArticles = (): Article[] => {
  return articles.filter((a) => a.isHot);
};

export const getNewArticles = (): Article[] => {
  return articles.filter((a) => a.isNew);
};

export const getRelatedArticles = (article: Article, count: number = 3): Article[] => {
  return articles
    .filter((a) => a.slug !== article.slug && (a.category === article.category || a.tags.some((t) => article.tags.includes(t))))
    .slice(0, count);
};